import React, { useCallback, useEffect, useRef } from "react";
import Slider from "react-slick";
import { Col, Image, Row } from "react-bootstrap";
import classNames from "classnames";
import useWindowSize from "../../../hooks/useWindowSize";

const SectionCarousel = ({
  onChange = (_current) => {},
  activeCarousel = 0,
  cardContentLomba = [],
}) => {
  const { size } = useWindowSize();
  const sliderRef = useRef();

  const mobileView = () => {
    return (size?.width || 0) <= 830;
  };

  const settings = {
    dots: mobileView(),
    autoplay: mobileView(),
    autoplaySpeed: 15000,
    infinite: false,
    speed: 100,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !mobileView(),
    afterChange: (current) => onChange(current + 1),
    customPaging: (i) => (
      <div className="dots-container">
        <div
          className={classNames({
            "dots-active": i === activeCarousel - 1,
            "dots-inactive": i !== activeCarousel - 1,
          })}
        ></div>
      </div>
    ),
  };

  const _renderChampionPrice = (content = []) => (
    <>
      {[...content].map((data, index) => (
        <Row
          key={index}
          className="section-carousel__right__champion-card-price"
        >
          <Col>
            <Image src={data?.icon} alt={data?.title} />
          </Col>
          <Col>
            <span className="section-carousel__right__champion-card-body__text">
              {data?.title}
            </span>
            <h3 className="section-carousel__right__champion-card-body__price">
              {data?.price}
            </h3>
          </Col>
        </Row>
      ))}
    </>
  );

  const _renderContentFooter = (footer) => {
    if (typeof footer === "object") {
      return (
        <>
          <p className="section-carousel__left__paragraph">{footer?.title}</p>
          <ul className="section-carousel__left__paragraph-list">
            {footer.list.map((text, idx) => (
              <li key={idx} className="section-carousel__left__paragraph">
                {text}
              </li>
            ))}
          </ul>
        </>
      );
    }
    return <p className="section-carousel__left__paragraph">{footer}</p>;
  };

  const handleBoldWord = (list, boldWord = []) => {
    if (boldWord.length <= 0) return list;
    return list.replace(
      new RegExp("(\\b)(" + boldWord.join("|") + ")(\\b)"),
      "$1<b>$2</b>$3"
    );
  };

  const handleSlickGoTo = useCallback(() => {
    sliderRef.current.slickGoTo(activeCarousel - 1);
  }, [activeCarousel]);

  useEffect(() => {
    handleSlickGoTo();
  }, [handleSlickGoTo]);

  return (
    <Slider ref={sliderRef} {...settings}>
      {[...cardContentLomba].map((content, index) => (
        <div
          key={index}
          className={classNames("section-carousel", {
            [content?.sectionClass]: true,
          })}
        >
          <Row>
            <Col className="section-carousel__right order-lg-2">
              <div className="section-carousel__right__champion-card">
                <div
                  className={classNames(
                    "section-carousel__right__champion-card-head",
                    {
                      [content?.headerClass]: true,
                    }
                  )}
                >
                  <h5 className="section-carousel__right__champion-card-text">
                    Hadiah
                  </h5>
                  <div className="section-carousel__right__champion-card-image-container">
                    <Image
                      className="section-carousel__right__champion-card-image"
                      src={content?.iconhHeader}
                      alt={`Hadiah ${content?.title}`}
                    />
                  </div>
                </div>
                <div className="section-carousel__right__champion-card-body">
                  {_renderChampionPrice(content?.championList)}
                </div>
              </div>
            </Col>
            <Col className="section-carousel__left order-lg-1">
              <p className="section-carousel__left__text">Detail Informasi</p>
              <h2 className="section-carousel__left__type-text">
                {content?.title}
              </h2>
              <p className="section-carousel__left__paragraph">
                {content?.description?.title}
              </p>
              <ol
                className={classNames({
                  "section-carousel__left__paragraph-list":
                    content.description.title !== null,
                })}
              >
                {content?.description?.list.map((list, idx) => (
                  <li
                    key={idx}
                    dangerouslySetInnerHTML={{
                      __html: handleBoldWord(
                        list,
                        content?.description?.boldWord
                      ),
                    }}
                    className="section-carousel__left__paragraph"
                  >
                    {/* {handleBoldWord(list, content?.description?.boldWord)} */}
                  </li>
                ))}
              </ol>
              {content?.description?.title2 && (
                <p className="section-carousel__left__paragraph">
                  {content?.description?.title2}
                </p>
              )}
              <ol
                className={classNames({
                  "section-carousel__left__paragraph-list":
                    content.description.title2 !== null,
                })}
              >
                {content?.description?.list2 &&
                  content?.description?.list2.map((list, idx) => (
                    <li
                      key={idx}
                      dangerouslySetInnerHTML={{
                        __html: handleBoldWord(
                          list,
                          content?.description?.boldWord
                        ),
                      }}
                      className="section-carousel__left__paragraph"
                    ></li>
                  ))}
              </ol>
              {content?.description?.footer &&
                _renderContentFooter(content?.description?.footer)}

              {/* <Button
                className="section-carousel__main-button"
                variant="primary-orange"
                size="large"
                onClick={() => {
                  if (typeof window !== "undefined") {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: content?.eventGTM,
                      eventProps: {
                        category: "Custom Event",
                        action: "Piala by.U",
                        label: `Daftar Sekarang ${content?.title}`,
                      },
                    });
                    window.open(content?.description?.url, "_blank").focus();
                  }
                }}
              >
                Daftar Sekarang!
              </Button> */}
            </Col>
          </Row>
        </div>
      ))}
    </Slider>
  );
};

export default SectionCarousel;
